import * as React from "react";
import clx from "clsx";
import Box from "../box";
import type { LinkProps } from "./link.types";

function Link(props: LinkProps) {
  return (
    <Box
      fontFamily="$body"
      fontSize="$sm"
      as={props.as}
      backgroundColor={props.background ? "$cardBg" : undefined}
      p={props.background ? "$2" : undefined}
      borderRadius={props.background ? "$md" : undefined}
      color={
        props.color
          ? props.color
          : {
              base: "$link",
              hover: "$link",
            }
      }
      textDecoration={{
        base: "none",
        hover: props.underline ? "underline" : "none",
      }}
      attributes={{
        ...props.attributes,
        href: props.href,
        target: props.target,
        rel: props.rel,
      }}
      className={clx(props.className)}
    >
      {props.children}
    </Box>
  );
}

Link.defaultProps = { as: "a", underline: true, rel: "noopener noreferrer" };

export default Link;
